import {SurveyAnalyticsEvent} from "./SurveyAnalyticsEvent";

export class SurveyContentEvent extends SurveyAnalyticsEvent {
  type = 'SURVEY_CONTENT_EVENT';
  dayOffset: number;
  contentId: string;
  origin: string = 'myair' // Hardcoded for now since myAir is the only client.
  locale: string;
}